import React from "react";
import JSONPretty from "react-json-pretty";
import styled from "styled-components";
import Branding from "../../config/Branding";
import { StreamEvent } from "./useEventStream";

const DetailWrapper = styled.div`
    background: ${Branding.darkBackground};
    padding: 10px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 0.85em;
    overflow-x: auto;
`;

type EventStreamDetailProps = {
    event: StreamEvent;
}

const EventStreamDetail: React.FC<EventStreamDetailProps> = ({ event }) => {
    return (
        <DetailWrapper>
            <JSONPretty data={event} />
        </DetailWrapper>
    );
};

export default EventStreamDetail;
